import PropTypes from 'prop-types';
import React from 'react';

import { useCountdown } from '../../hooks/use-countdown';

const renderTimeCounter = (days, hours, minutes, seconds) => {
  if (days > 1) {
    return `${days} days${hours > 0 ? `, ${hours} hour${hours > 1 ? 's' : ''}` : ''}`;
  }

  if (days === 1) {
    return `${days} day${hours > 0 ? `, ${hours} hour${hours > 1 ? 's' : ''}` : ''}`;
  }

  if (hours > 0) {
    return `${hours} hour${hours > 1 ? 's' : ''}${minutes > 0 ? `, ${minutes} minute${minutes > 1 ? 's' : ''}` : ''}`;
  }

  if (minutes > 0 && seconds > 0) {
    return `${minutes} minute${minutes > 1 ? 's' : ''}, ${seconds} second${seconds > 1 ? 's' : ''}`;
  }

  if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
  }

  if (seconds > 0) {
    return `${seconds} second${seconds > 1 ? 's' : ''}`;
  }
  
  return '';
};

function CountdownTimer({ targetDate, leftText, hideTimer }) {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);
 
  if (days + hours + minutes + seconds <= 0) {   
    return '';
  }

  return (!hideTimer && (
    <>
      {renderTimeCounter(days, hours, minutes, seconds)}
      <span>{leftText}</span>
    </>
  )
  );
}

CountdownTimer.defaultProps = { hideTimer: false, item: { requestAccessKey: 0, enddate: '' } };

CountdownTimer.propTypes = {
  targetDate: PropTypes.string.isRequired,
  leftText: PropTypes.string.isRequired,
  item: PropTypes.shape({
    requestAccessKey: PropTypes.number,
    enddate: PropTypes.string,
  }),
  hideTimer: PropTypes.bool,
};

export default CountdownTimer;
